import { IUser } from '~/src/dash/api/console-api';

export type ROLE = string;
export const ROLE_ADMIN: ROLE = 'admin';
export const ROLE_USER: ROLE = 'user';
export const ROLE_SUPER: ROLE = 'super';
export const ROLE_TECHNICAL: ROLE = 'technical';
export const ROLE_RESELLER: ROLE = 'reseller';
export const ROLE_PARENT_PUBLISHER: ROLE = 'parentpublisher';


export type ROLE_ID = number;
export const ROLE_ID_SUPER: ROLE_ID = 3;

export function hasRole(user: IUser, roleName: ROLE[]): boolean {
  return roleName.reduce((ret, roleID) => {
    return ret || roleID === user.Role.Name;
  }, false);
}

export function isSuper(user: IUser) {
  return ROLE_SUPER === user.Role.Name;
}

export function checkUserInfoMasked(user: IUser) {
  return ['131', '168', '186', '581', '585', '696'].includes(user.ID);
}

export function hasRoleSuperUser(user: IUser): boolean {
  return hasRole(user, [ROLE_SUPER]);
}

export function isInternalUser(user: IUser): boolean {
  const internalDomains = ['getpublica.com', 'integralads.com', 'publica-project.com'];
  return internalDomains.some((domain) => user.Username.includes(domain));
}

export function hasRoleAdmin(user: IUser) {
  return ROLE_ADMIN === user.PermissionRole.name;
}

export type PERMISSION_ROLE = number;
export const PERMISSION_ROLE_SAMSUNG_SUPER_USER = 203;

export function hasPermSuperUser(publisherID: string, permissionRoleID: number): boolean {
  const superUserPermMap: { [key: string]: number } = {
    394: PERMISSION_ROLE_SAMSUNG_SUPER_USER,
  };
  return superUserPermMap[publisherID] === permissionRoleID;
}
